import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader, Field } from "@/components/common";

export default function Account() {
  const { user, loadSession } = useApp();
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const [disablePw, setDisablePw] = useState("");
  useEffect(() => { setSetup(null); }, [user?.mfa_enabled]);
  const change = async () => {
    try { await api.post("/auth/change-password", pw); toast.success("Password changed"); setPw({ current_password: "", new_password: "" }); } catch (e) { toast.error(errMsg(e)); }
  };
  const enable = async () => {
    try { await api.post("/auth/mfa/enable", { code }); toast.success("Multi-factor authentication enabled"); loadSession(); } catch (e) { toast.error(errMsg(e)); }
  };
  const disable = async () => {
    try { await api.post("/auth/mfa/disable", { password: disablePw }); toast.success("MFA disabled"); loadSession(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader title="My Account" subtitle={`${user.name} · ${user.email}`} />
      <section className="panel mb-6 p-5">
        <h2 className="mb-4 text-base font-semibold">Multi-factor authentication</h2>
        {user.mfa_enabled ? (
          <div className="flex flex-col gap-2 md:flex-row" data-testid="mfa-enabled">
            <span className="text-sm text-emerald-700">MFA is enabled for your account.</span>
            <input className="inp md:w-56" type="password" placeholder="Password to disable" value={disablePw} onChange={(e) => setDisablePw(e.target.value)} data-testid="mfa-disable-password" />
            <button className="btn btn-ghost" onClick={disable} data-testid="mfa-disable-btn">Disable</button>
          </div>
        ) : !setup ? (
          <button className="btn btn-primary" onClick={() => api.post("/auth/mfa/setup").then((r) => setSetup(r.data))} data-testid="mfa-setup-btn">Set up authenticator app</button>
        ) : (
          <div className="flex flex-col gap-4 md:flex-row">
            <img src={setup.qr} alt="MFA QR code" className="h-44 w-44 rounded border bg-white p-2" data-testid="mfa-qr" />
            <div className="space-y-3 text-sm">
              <p>Scan with Google Authenticator, Microsoft Authenticator or similar. Manual key: <code className="break-all">{setup.secret}</code></p>
              <input className="inp w-40 tracking-[0.3em]" maxLength={6} value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" data-testid="mfa-code-input" />
              <button className="btn btn-primary" onClick={enable} data-testid="mfa-enable-btn">Verify & enable</button>
            </div>
          </div>
        )}
      </section>
      <section className="panel p-5">
        <h2 className="mb-4 text-base font-semibold">Change password</h2>
        <div className="grid gap-3 md:grid-cols-3">
          <Field label="Current password"><input className="inp" type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="current-password-input" /></Field>
          <Field label="New password (10+ chars)"><input className="inp" type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="new-password-input" /></Field>
          <div className="flex items-end"><button className="btn btn-primary" onClick={change} data-testid="change-password-btn">Update password</button></div>
        </div>
      </section>
    </div>
  );
}
